// extracted by mini-css-extract-plugin
module.exports = {"message":"IntegrationsError_message___oHAZ","text":"IntegrationsError_text__xPk0d"};